import { defineStore } from 'pinia'
import { ref } from 'vue'
import { MonitoredArea } from '../../../../@core/monitored-area/domain/entities/MonitoredArea'

export const useExclusionZoneStore = defineStore('exclusionZone', () => {
	const initState = {
		id: undefined,
		description: '',
		name: '',
		monitoredAreaId: '',
	}

	const exclusionZone = ref({ ...initState })

	const monitoredAreas = ref<MonitoredArea[]>([])

	return {
		exclusionZone,
		monitoredAreas,
	}
})
